import { Component } from '@angular/core';

@Component({
  selector: 'app-category-display',
  templateUrl: './category-display.component.html',
  styleUrl: './category-display.component.scss'
})

export class CategoryDisplayComponent {
  categories : any = [
    {
      title: 'CBD',
      writeUp: 'CBD oil, derived from cannabis, offers natural relief for sleep, skin, and pain concerns, providing versatile wellness support',
      image: 'ahmed-zayan-1svWCsnnrT8-unsplash.jpg' 
    },
    {
      title: 'THC',
      writeUp: 'CBD oil, derived from cannabis, offers natural relief for sleep, skin, and pain concerns, providing versatile wellness support',
      image: 'budding-h3PWUqxpP_0-unsplash.jpg' 
    },
    {
      title: 'Tools',
      writeUp: 'CBD oil, derived from cannabis, offers natural relief for sleep, skin, and pain concerns, providing versatile wellness support',
      image: 'elsa-olofsson-Et2GCPYzze4-unsplash.jpg' 
    },
    {
      title: 'Things',
      writeUp: 'CBD oil, derived from cannabis, offers natural relief for sleep, skin, and pain concerns, providing versatile wellness support',
      image: 'wesley-gibbs-NxRx7_mPdEk-unsplash.jpg' 
    }

  ]

}
